import { render, staticRenderFns } from "./watermark.vue?vue&type=template&id=c27aeca4&scoped=true"
import script from "./watermark.vue?vue&type=script&lang=js"
export * from "./watermark.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c27aeca4",
  null
  
)

export default component.exports